import React from 'react';
import { Form, Input, Collapse, Space, Tag } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { AMAZON_SITES } from '../../types';

interface SiteKeywordsCollapseProps {
    keywordsBySite: Record<string, string>;
    onUpdate: (siteCode: string, value: string) => void;
}

export const SiteKeywordsCollapse: React.FC<SiteKeywordsCollapseProps> = ({
    keywordsBySite,
    onUpdate,
}) => {
    return (
        <Form.Item
            label={
                <Space>
                    <GlobalOutlined />
                    分站点核心关键词
                </Space>
            }
            tooltip="各站点的核心关键词，用逗号分隔，AI会将其有机融入文案"
        >
            <Collapse
                size="small"
                defaultActiveKey={['US']}
                items={AMAZON_SITES.map(site => ({
                    key: site.code,
                    label: (
                        <Space>
                            <Tag>{site.code}</Tag>
                            {site.name}
                            {keywordsBySite[site.code] && (
                                <Tag color="green">
                                    {keywordsBySite[site.code].split(',').filter(k => k.trim()).length} 词
                                </Tag>
                            )}
                        </Space>
                    ),
                    children: (
                        <Input.TextArea
                            value={keywordsBySite[site.code] || ''}
                            onChange={e => onUpdate(site.code, e.target.value)}
                            placeholder={`输入 ${site.name} 站点的核心关键词，用逗号分隔`}
                            autoSize={{ minRows: 2, maxRows: 4 }}
                        />
                    ),
                }))}
            />
        </Form.Item>
    );
};
